var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-event-list"},[(_vm.events.length)?_c('r-simple-list',{attrs:{"list":_vm.events},on:{"click-handler":_vm.clickHandler}}):_c('div',{staticClass:"m-event-list__nodata"},[_c('r-text',{attrs:{"type":"caption"}},[_vm._v(" Нет ни одного события. Создайте первое на карте, чтобы настроить сценарий и запустить расчёт ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }